import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import style from './style.module.less';
import { MDash } from 'ui-components/components/mdash';

const name = <FormattedMessage {...messages.availableColumnHeader} />;

export default {
  getMessageDescriptor: () => messages.availableColumnHeader,
  name,
  render: (data) => (
    <div className={style['right-align-column']}>
      {data.inventoryDisabled && <MDash />}
      {!data.inventoryDisabled && (data.inventory?.available ?? 0)}
    </div>
  ),
};
